/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Fragment } from "react";
import { Close } from "@mui/icons-material";
import { Autocomplete, Box, Chip, TextField } from "@mui/material";

import { useStyles } from "./styles";
import { IAutoCompleteProps, ISubGroupDataType } from "../../models/common/AutoComplete";

const AutoCompleteComponent = (props: IAutoCompleteProps) => {
  const classes = useStyles();
  const {
    subGroupData,
    label,
    id,
    onSelectionChange,
    values,
    isMultiple,
    required = true,
    disableClearable = false,
    helperText = "",
    error = false,
  } = props;
  const limitTags = 8;
  const renderTagsComponent = (value: ISubGroupDataType[], getTagProps: any) => {
    const tags = value.map((option: ISubGroupDataType, index: number) => {
      if (limitTags > index) {
        return (
          <Chip
            key={index}
            variant="outlined"
            label={option.name}
            deleteIcon={<Close fontSize="small" />}
            {...getTagProps({ index })}
          />
        );
      }
      return null;
    });
    return limitTags > value.length - 1 ? (
      tags
    ) : (
      <Fragment>
        {tags}
        <span id="tagsCount">+{value.length - limitTags}</span>
      </Fragment>
    );
  };
  return (
    <Box className={classes.root}>
      <Autocomplete
        id={id}
        value={values}
        multiple={isMultiple}
        options={subGroupData}
        disableClearable={disableClearable}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label={label}
            error={error}
            variant="standard"
            aria-label={label}
            required={required}
            helperText={helperText}
            className={classes.textFieldRoot}
          />
        )}
        onChange={onSelectionChange}
        renderTags={renderTagsComponent}
      />
    </Box>
  );
};

export default AutoCompleteComponent;
